export const RecruitmentConfiguration = {
    path: '/recruitments_configuration',
    name: 'recruitments_configuration',
    component: () => import('@/views/Recruitment/RecruitmentConfiguration.vue'),
}